/**
 * Adiciona uma regra a tela de vinculação de usuarios em que
 * os campos serão requeridos somente se um da mesma linha for
 * preenchido tambem, ficando assim um ligado ao outro
 */
function RegrasVinculoUsuarios() {
  $('[name^=usuarios]').each(function (index, element) {
    $(element).rules('add', {
      required: function (el) {
        // Se for o campo de 'idFuncionario' será requerido se
        // o campo 'conta' for preenchido, e vice versa
        const name = el.name.indexOf('conta') >= 0
          ? el.name.replace('conta', 'idFuncionario')
          : el.name.replace('idFuncionario', 'conta');

        return $('[name="' + name + '"]').val().length > 0;
      }
    });
  });
}

module.exports = RegrasVinculoUsuarios;
